import Filter from '../../controllers/filter';
import rights from '../../../../components/rights';
import { getChildrenByTaskId } from '../../helpers/ganttHelpers';

export default instance => {
  instance.attachEvent('onBeforeTaskDisplay', (id, task) => {
    const userResourceId = instance.config.userResourceId;
    let displayTask = false;

    if (task.type === instance.config.types.button && !instance.config.show_advanced_buttons) displayTask = false;
    else if (rights.project.hasRight(task.gantt_id, 'all_tasks')) {
      displayTask = true;
    } else if (task.type !== instance.config.types.task && task.type !== instance.config.types.milestone && task.type !== instance.config.types.project) displayTask = true;
    else if (task.type === instance.config.types.project) {
      const childrenTasks = getChildrenByTaskId(instance, task.id);
      const hasAssignedChildrenTask = childrenTasks.some(t => t.resources?.find(r => r.resource_id === userResourceId));

      displayTask = task.parent === 0 ? true : hasAssignedChildrenTask;
    } else displayTask = !!task.resources.find(r => r.resource_id === userResourceId);

    if (Filter.filterApplied && displayTask) {
      displayTask = !!Filter.foundTasksMap[id];
    }

    return displayTask;
  });
};
